import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';
import { Button } from './Button';
import { MODAL_OVERLAY_CLASS, MODAL_PANEL_CLASS } from '@/styles/classes';

type ConfirmDialogProps = {
  open: boolean;
  paragraphs: string[];
  confirmLabel: string;
  confirming: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmDialog({
  open,
  paragraphs,
  confirmLabel,
  confirming,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const { t } = useTranslation();

  if (!open) {
    return null;
  }

  return (
    <div className={clsx(MODAL_OVERLAY_CLASS, 'z-[60]')} onClick={onCancel}>
      <div
        className={clsx(MODAL_PANEL_CLASS, 'max-w-lg p-8')}
        onClick={event => event.stopPropagation()}
      >
        {paragraphs.map((text, index) => (
          <p
            key={index}
            className={`text-center text-base leading-6 text-unilink-text-primary${index > 0 ? ' mt-4' : ''}`}
          >
            {text}
          </p>
        ))}
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Button
            variant="danger"
            onClick={onConfirm}
            disabled={confirming}
            className="bg-salmon hover:bg-logout-hover"
          >
            {confirmLabel}
          </Button>
          <Button variant="secondary" onClick={onCancel} disabled={confirming}>
            {t('common.cancel')}
          </Button>
        </div>
      </div>
    </div>
  );
}
